import { render, staticRenderFns } from "./IconPlan.vue?vue&type=template&id=64b93030&lang=pug"
import script from "./IconPlan.vue?vue&type=script&lang=js"
export * from "./IconPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports